import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';

// Local Deps
import './ItemDescInfo.scss';
import { columns } from './gridConfig';
import makeItemDescInfoObj from './makeItemDescInfoObj';
import displayHyperlinks from './displayHyperlinks';

export default class ItemDescInfoGrid extends React.PureComponent {
  static propTypes = {
    itemDescInfoText: PropTypes.string.isRequired,
  };

  render() {
    const { itemDescInfoText } = this.props;
    const itemDescInfo = makeItemDescInfoObj(itemDescInfoText)

    return (
      <div>
        {displayHyperlinks(itemDescInfo.description)}
        <hr />
        <div className="nf-tech-info__grid">
          <ReactTable
            data={itemDescInfo.requirements}
            columns={columns}
            defaultPageSize={itemDescInfo.requirements.length < 5 ? itemDescInfo.requirements.length : 5}
            noDataText={itemDescInfo.requirements.length === 0 ? 'No Data Found' : null}
            showPagination={itemDescInfo.requirements.length > 5}
            style={{ textAlign: 'center' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/ItemDescInfoGrid/ItemDescInfoGrid.jsx